export default __webpack_public_path__ + "static/media/B0006.5bafd8ad.png";